import React from 'react'
import './LoadingScreen.scss'

const LoadingScreen = () => {
    return (
        <div className="spinner">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
        </div>
    )
}

export default LoadingScreen
